export default "__VITE_ASSET__CnlyA_$3__"